import styled from "styled-components";

export const RewardOfflineDetailContainerStyled = styled.div`
  border-radius: 1rem;
  padding: 1.25rem;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  .block_section {
    margin-bottom: 2rem;
    .title {
      margin-bottom: 23px;
      font-size: ${({ theme }) => theme.FONT.SIZE.S15};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    }
    .sub_title {
      margin-bottom: 19px;
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    }
    .body {
      width: 100%;
      display: flex;
      .body_left {
        flex: 1;
        display: flex;
        flex-direction: column;
        white-space: nowrap;
        .value_item_wrap {
          margin-bottom: 8px;
        }
      }
      .body_right {
        flex: 1;
        white-space: nowrap;
        .value_item_wrap {
          margin-bottom: 8px;
          flex: 1;
        }
      }
    }
  }
  .line {
    margin: 19px 0 21px 0;
    border-bottom: 1px solid ${({ theme }) => theme.COLORS.GRAY_11};
  }

  .filter_wrap {
    margin-bottom: 1rem;
  }
  .body_table {
    margin-bottom: 21px;
  }
  .btn_wrap {
    display: flex;
    justify-content: flex-end;
    .w120 {
      width: 120px;
    }
  }
`;
